import {useEffect} from 'react';
import {addMinutes} from 'date-fns';
import Cookies from 'universal-cookie';
import {REDIRECT_TO} from '@/shared/const/cookies';
import {LOGOUT} from '@/shared/routing/paths';

export function useRedirectCookie(isLoggedIn: boolean, pathname: string) {
  useEffect(() => {
    const cookies = new Cookies();
    if (!isLoggedIn && pathname !== LOGOUT) {
      const expires = addMinutes(new Date(), 30);
      cookies.set(REDIRECT_TO, pathname, {expires});
    } else if (isLoggedIn) {
      cookies.remove(REDIRECT_TO);
    }
  }, [isLoggedIn, pathname]);
}
